import styled from 'styled-components'
import type { StepStatus } from './Stepper.types'

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;

  @media (max-width: 768px) {
    overflow-x: auto;
    justify-content: flex-start;
  }
`

export const StepItem = styled.div<{
  $status: StepStatus
  $clickable: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  flex: 1;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  opacity: ${({ $status }) => ($status === 'pending' ? 0.6 : 1)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: ${({ $clickable }) => ($clickable ? 1 : undefined)};
  }

  @media (max-width: 768px) {
    flex: 0 0 auto;
    min-width: 80px;
  }
`

export const StepIconWrapper = styled.div<{ $status: StepStatus }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, $status }) =>
    $status === 'completed'
      ? theme.colors.success
      : $status === 'current'
        ? theme.colors.primary
        : $status === 'warning'
          ? theme.colors.warning
          : theme.colors.background.secondary};
  color: ${({ theme, $status }) =>
    $status === 'completed' || $status === 'current' || $status === 'warning'
      ? theme.colors.background.primary
      : theme.colors.text.secondary};
  border: 2px solid
    ${({ theme, $status }) =>
      $status === 'completed'
        ? theme.colors.success
        : $status === 'current'
          ? theme.colors.primary
          : $status === 'warning'
            ? theme.colors.warning
            : theme.colors.border.default};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }
`

export const StepTitle = styled.span<{ $status: StepStatus }>`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme, $status }) =>
    $status === 'current'
      ? theme.typography.fontWeight.semibold
      : theme.typography.fontWeight.normal};
  color: ${({ theme, $status }) =>
    $status === 'current'
      ? theme.colors.text
      : $status === 'completed'
        ? theme.colors.text
        : theme.colors.text.secondary};
  text-align: center;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    max-width: 80px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`

export const StepConnector = styled.div<{ $completed: boolean }>`
  flex: 1;
  height: 2px;
  background: ${({ theme, $completed }) =>
    $completed ? theme.colors.success : theme.colors.border.default};
  margin: 0 ${({ theme }) => theme.spacing.small};
  transition: background 0.3s ease;

  @media (max-width: 768px) {
    min-width: 20px;
    max-width: 40px;
  }

  @media (max-width: 480px) {
    min-width: 10px;
    max-width: 20px;
  }
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: ${({ theme }) => theme.colors.background.secondary};
  margin-top: ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  overflow: hidden;

  @media (min-width: 769px) {
    display: none;
  }
`

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background: ${({ theme }) => theme.colors.primary};
  transition: width 0.3s ease;
`
